function getMessage(field, args) {
  return `${field} not allowed.`
}

function validate(value, args) {
  return !value
}

export default {
  getMessage,
  validate
}
